import { render, staticRenderFns } from "./FontesPOL.vue?vue&type=template&id=279cc21f&scoped=true"
import script from "./FontesPOL.vue?vue&type=script&lang=js"
export * from "./FontesPOL.vue?vue&type=script&lang=js"
import style0 from "./FontesPOL.vue?vue&type=style&index=0&id=279cc21f&prod&scoped=true&lang=css"
import style1 from "./FontesPOL.vue?vue&type=style&index=1&id=279cc21f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279cc21f",
  null
  
)

export default component.exports